import { render, staticRenderFns } from "./message-custom.vue?vue&type=template&id=61f02d6c&scoped=true"
import script from "./message-custom.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-custom.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-custom.vue?vue&type=style&index=0&id=61f02d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f02d6c",
  null
  
)

export default component.exports